import Stat from "./Stat";

export default Stat;
